var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Tipo de cuenta"),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.account_type ? "is-invalid" : "",
            attrs: { items: _vm.accounts, "hide-details": "" },
            model: {
              value: _vm.data.account_type,
              callback: function ($$v) {
                _vm.$set(_vm.data, "account_type", $$v)
              },
              expression: "data.account_type",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.account_type, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _vm.data.account_type == 2
        ? _c(
            "div",
            { staticClass: "form-group mb-2" },
            [
              _c("small", { staticClass: "input-title" }, [
                _vm._v("Nombre de la Empresa"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.company,
                    expression: "data.company",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.company ? "is-invalid" : "",
                attrs: { type: "text" },
                domProps: { value: _vm.data.company },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "company", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.company, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _vm.data.account_type != 2
        ? _c(
            "div",
            { staticClass: "form-group mb-2" },
            [
              _c("small", { staticClass: "input-title" }, [_vm._v("Nombre")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.first_name,
                    expression: "data.first_name",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.first_name ? "is-invalid" : "",
                attrs: { type: "text" },
                domProps: { value: _vm.data.first_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "first_name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.first_name, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _vm.data.account_type != 2
        ? _c(
            "div",
            { staticClass: "form-group mb-2" },
            [
              _c("small", { staticClass: "input-title" }, [_vm._v("Apellido")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.last_name,
                    expression: "data.last_name",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.last_name ? "is-invalid" : "",
                attrs: { type: "text" },
                domProps: { value: _vm.data.last_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "last_name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.last_name, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      (_vm.data.role ? _vm.data.role.name == "warehouses" : false)
        ? _c(
            "div",
            { staticClass: "form-group mb-2" },
            [
              _c("small", { staticClass: "input-title" }, [_vm._v("Bodega")]),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "form-control form-control-sm",
                class: _vm.errors.warehouse_id ? "is-invalid" : "",
                attrs: {
                  items: _vm.warehouses,
                  "item-text": function (item) {
                    return item.code + "-" + item.name
                  },
                  "item-value": "id",
                  "hide-details": "",
                  "no-data": "",
                },
                model: {
                  value: _vm.data.warehouse_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "warehouse_id", $$v)
                  },
                  expression: "data.warehouse_id",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.warehouse_id, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      (
        _vm.data.role
          ? _vm.data.role.name != "customers" && _vm.data.role.name != "drivers"
          : false
      )
        ? _c(
            "div",
            { staticClass: "form-group mb-2" },
            [
              _c("small", { staticClass: "input-title" }, [
                _vm._v("Sucursal de entrega"),
              ]),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "form-control form-control-sm",
                class: _vm.errors.deliver_branch_office ? "is-invalid" : "",
                attrs: {
                  items: _vm.branch_offices,
                  "item-text": "name",
                  "item-value": "id",
                  "hide-details": "",
                  "no-data": "",
                },
                model: {
                  value: _vm.data.deliver_branch_office,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "deliver_branch_office", $$v)
                  },
                  expression: "data.deliver_branch_office",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.deliver_branch_office, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Correo Electrónico"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.email,
                expression: "data.email",
              },
            ],
            staticClass: "form-control form-control-sm",
            class: _vm.errors.email ? "is-invalid" : "",
            attrs: { type: "email" },
            domProps: { value: _vm.data.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "email", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.email, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c("div", { staticClass: "form-group mb-2" }, [
        _c("small", { staticClass: "input-title" }, [_vm._v("Código")]),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control form-control-sm",
          attrs: { type: "text", readonly: "" },
          domProps: { value: _vm.data.type + _vm.data.id },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [_vm._v("Genero")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.gender ? "is-invalid" : "",
            attrs: { items: _vm.genders, "hide-details": "" },
            model: {
              value: _vm.data.gender,
              callback: function ($$v) {
                _vm.$set(_vm.data, "gender", $$v)
              },
              expression: "data.gender",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.gender, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }